import { TOGGLE_APPSMORE, TOGGLE_PLAN, TOGGLE_ADD_FEEDS, TOGGLE_MANAGE_FEEDS_D, TOGGLE_CUSTOMIZATION, TOGGLE_THEMES_SECTION, TOGGLE_PUBLISH } from "./keys";

const reset = {
    showPricing: false,
    showAppsMore: false,
    showAddFeed: false,
    showManageFeed: false,
    showThemes: false,
    showCustomization: false,
    showPublish: false,
    showUgcSuit:false

}
const initialState = {
    ...reset,

}

export default function reducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {

        case TOGGLE_PLAN: {
            return {
                ...reset, showPricing: payload
            }
        }

        case TOGGLE_APPSMORE: {
            return {
                ...reset, showAppsMore: payload
            }
        }

        case TOGGLE_ADD_FEEDS: {
            return {
                ...reset, showAddFeed: payload,

            }
        }

        case TOGGLE_MANAGE_FEEDS_D: {
            return {
                ...reset, showManageFeed: payload,

            }
        }

        case TOGGLE_THEMES_SECTION: {
            return {
                ...reset, showThemes: payload,
            }
        }

        case TOGGLE_CUSTOMIZATION: {
            return {
                ...reset,
                showCustomization: payload
            }
        }
        case TOGGLE_PUBLISH: {
            return {
                ...reset,
                showPublish: payload
            }
        }

        default:
            return { ...state }
    }
}